import * as axios from '@/axios/index';
import { isSingleCoin } from '@/i18n/currency';

function getTappayRedirectStatus(route) {
  const status = route && route.query && route.query.status;
  if (status !== undefined) return String(status);
  if (typeof window === 'undefined') return '';

  const match = window.location.search.match(/[?&]status=([^&]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

function buildTappayResultRedirect(route, successPath, failPath) {
  return {
    path: getTappayRedirectStatus(route) === '0' ? successPath : failPath,
    query: route.query
  };
}

// 收入轉餘額
const routers = [
  {
    path: '/rules',
    name: 'LegalRules',
    component: () => import('./pages/legal/index.vue'),
    props: {
      titleKey: 'legal_rules_title',
      contentKey: 'who_4'
    }
  },
  {
    path: '/privacy',
    name: 'LegalPrivacy',
    component: () => import('./pages/legal/index.vue'),
    props: {
      titleKey: 'legal_privacy_title',
      contentKey: 'who_5'
    }
  },
  {
    path: '/transfer-balance',
    name: 'TransferBalance',
    redirect: '/transfer-nicee?page=1'
    // component: () => import('./pages/transfer-balance')
  },
  // 儲值頁面
  {
    path: '/app-recharge',
    name: 'appRecharge',
    component: () =>
      import(/* webpackChunkName: "app-recharge" */ './pages/recharge-page/index.vue'),
    meta: {
      waitUserInfo: true
    },
    beforeEnter(to, from, next) {
      console.log('this.beforeEnter');
      
      axios
        .get('/iap/isCn')
        .then(res => {
          if (res && res.data) {
            next('/region-limit');
          } else {
            next();
          }
        })
        .catch(() => {
          // 接口异常也跳转提示页
          next('/region-limit');
        });
    }
  },
  //购买nicee幣
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('./pages/recharge/index.vue'),
    meta: {
      waitUserInfo: true
    },
    beforeEnter(to, from, next) {
      axios
        .get('/iap/isCn')
        .then(res => {
          if (res && res.data) {
            next('/region-limit');
          } else {
            next();
          }
        })
        .catch(() => {
          // 接口异常也跳转提示页
          next('/region-limit');
        });
    }
  },
  // 印尼 Nicee 币储值
  {
    path: '/recharge-id',
    name: 'IndonesiaRecharge',
    component: () => import('./pages/recharge-id/index.vue'),
    meta: {
      waitUserInfo: true,
      region: 'ID'
    },
    beforeEnter(to, from, next) {
      axios
        .get('/iap/isCn', { region: 'ID' })
        .then(res => {
          if (res && res.data) {
            next('/region-limit');
          } else {
            next();
          }
        })
        .catch(() => next('/region-limit'));
    }
  },
  //购买钻石
  {
    path: '/diamond-recharge',
    name: 'DiamondRecharge',
    component: () => import('./pages/diamond-recharge'),
    meta: {
      waitUserInfo: true
    },
    beforeEnter(to, from, next) {
      // 印尼单一货币没有钻石，改去印尼金币储值页
      if (isSingleCoin) {
        next({ path: '/recharge-id', query: to.query, replace: true });
        return;
      }
      axios
        .get('/iap/isCn')
        .then(res => {
          if (res && res.data) {
            next('/region-limit');
          } else {
            next();
          }
        })
        .catch(() => {
          // 接口异常也跳转提示页
          next('/region-limit');
        });
    }
  },
  {
    path: '/rc-tappay-result',
    name: 'RcTappayResult',
    redirect: to => buildTappayResultRedirect(to, '/rc-success', '/rc-fail'),
    meta: {
      waitUserInfo: true
    }
  },
  //充值成功提示
  {
    path: '/rc-success',
    name: 'RcSuccess',
    component: () => import('./pages/recharge/recharge-success.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  //充值失败提示
  {
    path: '/rc-fail',
    name: 'RcFail',
    component: () => import('./pages/recharge/recharge-fail.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  //糖果管理
  {
    path: '/candy',
    name: 'Candy',
    component: () => import('./pages/candy')
  },
  // 收入赠送好友
  {
    path: '/gift-amount',
    name: 'GiftAmount',
    redirect: '/transfer-nicee?page=2'
    // component: () => import('./activities/gift-amount/index.vue')
  },
  // 收入轉餘額或收入赠送好友
  {
    path: '/transfer-nicee',
    name: 'TransferNicee',
    component: () => import('./pages/transfer-nicee/index.vue'),
    meta: {
      waitUserInfo: true
    }
  },
  // 我的收入
  {
    path: '/income',
    name: 'Income',
    component: () =>
      import(/* webpackChunkName: "income" */ './pages/income/index.vue')
  },
  // 帳單
  {
    path: '/bill',
    name: 'Bill',
    component: () =>
      import(/* webpackChunkName: "income" */ './pages/bill/index.vue')
  },
  // 帳單
  {
    path: '/overall-rating',
    name: 'OverallRating',
    component: () =>
      import(/* webpackChunkName: "income" */ './pages/overall-rating/index.vue')
  },
  // 帳單
  {
    path: '/language-setting',
    name: 'LanguageSetting',
    meta: {
      waitUserInfo: true
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ './pages/language-setting/index.vue')
  },
  {
    path: '/region-setting',
    name: 'RegionSetting',
    component: () =>
      import(/* webpackChunkName: "setting" */ './pages/region-setting/index.vue')
  },
  // 测试
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "test" */ './views/Test.vue')
  },
  // Doki 合作游戏 iframe
  {
    path: '/doki',
    name: 'Doki',
    component: () =>
      import(/* webpackChunkName: "doki" */ './pages/doki/index.vue')
  },
  // im消息跳转语音房
  {
    path: '/push-voice-room/:roomUid/:gameId?',
    name: 'PushVoiceRoom',
    component: () => import('./pages/push-voice-room/index.vue')
  },
  // logo
  {
    path: '/logo',
    name: 'Logo',
    component: () =>
      import(/* webpackChunkName: "logo" */ './views/logo/index.vue')
  },
  //绑定验证码
  {
    path: '/bind-invitation-code',
    name: 'BindInvitationCode',
    component: () =>
      import(/* webpackChunkName: "bindInvitationCode" */ './views/bind-invitation-code/index.vue')
  },
  {
    path: '/region-limit',
    name: 'RegionLimit',
    component: () => import('@/pages/region-limit/index.vue')
  },
    // 提领
  {
    path: '/ti-ling',
    name: 'Tiling',
    component: () =>
      import(/* webpackChunkName: "tiling" */ './pages/ti-ling/index.vue')
  },
    {
    path: '/setting-tiling-account',
    name: 'SettingTilingAccount',
    component: () => import('./pages/ti-ling/setting-account.vue')
  },
];

export default routers;
